import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-why-image-preview',
  templateUrl: './preview-image.component.html',
  styleUrls: ['./preview-image.component.scss']
})

export class PreviewImageComponent {
  @Input() image: any;

  constructor(public modalController: ModalController) {
  }

  dismiss(): void {
    this.modalController.dismiss();
  }
}
